import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ReservationRoutingModule } from './reservation-routing.module';
import { ReservationPage } from './reservation.page';
import { PickupItemComponent } from './pickup-item.component';
import { PickupOverviewComponent } from './pickup-overview/pickup-overview.component';
import { PickupOverviewModule } from './pickup-overview/pickup-overview.module';
import { ProductsModule } from '../products/products.module';

@NgModule({
  declarations: [
    ReservationPage,
    PickupItemComponent,
    PickupOverviewComponent,
  ],
  imports: [
    ReservationRoutingModule,
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
    PickupOverviewModule,
    ProductsModule, 
  ],
  exports: [
    ReservationPage,
  ],
})
export class ReservationModule { }
